
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M23.8 22.7l-6-6v-.5a5 5 0 000-8.4V3.2A1.5 1.5 0 0015.1 2L8.7 7.5 1.3.2a.8.8 0 00-1 0 .8.8 0 000 1.1l6.4 6.5H6a2 2 0 00-1.9 2v4.5a2 2 0 002 1.9h2.3l7 5.8a1.5 1.5 0 00.9.3 1.5 1.5 0 001.5-1.5v-2l5 5a.8.8 0 00.6.2.8.8 0 00.5-.2.8.8 0 000-1.1zm-6-12.8a3.4 3.4 0 010 4.2zm-1.6-6.7v12L9.7 8.5zm0 17.6l-7.1-6a.8.8 0 00-.5-.1H5.9a.4.4 0 01-.4-.4V9.7a.4.4 0 01.4-.4h2.3l8 8z","data-name":"Layer 1"}})])])
          )
        }
      }
    